import get from 'lodash.get';

/**
 * Formik ships with a onSubmit callback that is fired only if the form is valid.
 *
 * It does not however have a onError callback
 *
 * @param {FormikProps} formikProps Formik props (https://jaredpalmer.com/formik/docs/1.4.2/api/formik#props-1)
 * @param {*} onValidationError Callback function to fire when client side validation fails.
 */
export const onSubmitWithValidationError = (formikProps, onValidationError) => {
  const { submitForm, validateForm } = formikProps;

  return async e => {
    e.preventDefault();

    // If the onValidationError callback has been passed in
    if (typeof onValidationError === 'function') {
      // Runs the validation to get all of the errors
      const errors = await validateForm();
      const errorCount = Object.keys(errors).length;

      // If there are any errors pass them to the callback
      if (errorCount > 0) {
        onValidationError(errors);
      }
    }

    // Submit the form like usual
    submitForm();
  };
};

/**
 * Helper for getting and sanitizing formik values.
 *
 * Strings:
 * - All values are trimmed
 * - If empty or only containing spaces null will be returned
 *
 * Other:
 * - If no value found null will be returned
 *
 * @param {object} values Formik values (https://jaredpalmer.com/formik/docs/1.4.2/api/formik#values-field-string-any)
 * @param {string} path Path of value on values object.
 * @returns {*} Value or null.
 */
export const getValueNullifyIfEmpty = (values, path) => {
  const value = get(values, path, null) || null;

  if (typeof value === 'string') {
    const trimmed = value.trim();

    if (trimmed.length === 0) {
      return null;
    }

    return trimmed;
  }

  return value;
};
